import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  orderDetails: {},
};

const serviceRequestSlice = createSlice({
  name: "serviceRequest",
  initialState,
  reducers: {
    fetchOrderDetails(state, action) {
      state.loading = true;
    },
    fetchOrderDetailsSuccess(state, action) {
      state.orderDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchOrderDetailsFailure(state, action) {
      state.loading = false;
    },
    createServiceRequest(state, action) {
      state.loading = true;
    },
    createServiceRequestSuccess(state, action) {
      state.loading = false;
    },
    createServiceRequestFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = serviceRequestSlice;
